(() => {
  if (customElements.get('product-size-chart')) return;
  customElements.define('product-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-size-chart-open]');
      if (!dialog || !trigger || typeof dialog.showModal !== 'function') return;
      const close = () => dialog.close();
      trigger.addEventListener('click', event => {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      });
      this.querySelector('[data-size-chart-close]').addEventListener('click', close);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      dialog.addEventListener('close', () => trigger.focus());
    }
  });
})();
